import { makeAutoObservable } from "mobx"

export class DiagramStore {
  title: string = ''
  version: number = 0
  updateTime: string
  updateBy: string

  rootStore

  constructor(rootStore) {
    makeAutoObservable(this, {
      rootStore: false
    })
    this.rootStore = rootStore
  }
}